import { render, staticRenderFns } from "./ProductEditor.Vue?vue&type=template&id=1804b763"
import script from "./ProductEditor.Vue?vue&type=script&lang=js"
export * from "./ProductEditor.Vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductEditor.Vue
// module id = 191
// module chunks = 0